import Car from "./car";

export default class Magnet extends Phaser.GameObjects.Image { 
    private _defaultRadius: number;
    private _parent: Car;
    public body: Phaser.Physics.Arcade.Body;
    
    constructor(scene: Phaser.Scene, x: number, y: number, key: string, radius: number, parent: Car) {
        super(scene, x, y, key);
        // scene.add.existing(this);
        this._defaultRadius = radius;
        this._parent = parent;
        this._initPhysics();
        this.stop();
    }

    private _initPhysics() {
        this.scene.physics.world.enable(this);
        this.body.setAllowGravity(false);
        this.body.setAllowDrag(false);
        this.body.setAllowRotation(false);
        this.body.setImmovable(true);
        this.body.setCircle(this._defaultRadius);
        this.body.debugBodyColor = (0xffff00);
    }

    private _centerBodyOnBody (a, b) {
        if(a && b)
        {
            a.position.set(
              b.x + b.halfWidth - a.halfWidth,
              b.y + b.halfHeight - a.halfHeight
            );
        }
      }

    public setRadius(r: number) {
        r = (typeof r == "number") ? Math.max(r, 0) : this._defaultRadius;
        this.body.setCircle(r || this._defaultRadius);
    }

    private _startPhysics() {
        this.scene.physics.world.enable(this);
        this.body.setEnable(true);
    }

    private _stopPhysics() {
        this.scene.physics.world.disable(this);
        this.body.setEnable(false);
        this.body.stop();
    }

    update(time, dt) {
        this._centerBodyOnBody(this.body, this._parent.body);
    }

    public stop() {
        this.setActive(false);
        this._stopPhysics();
        this.setRadius(0);
        this.body.position.set(window.constants["DEAD_SPOT"].x, window.constants["DEAD_SPOT"].y);
    }

    public start() {
        this.setActive(true);
        this._startPhysics();
        this.setRadius(this._defaultRadius);
    }


}